var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-81.000000, -971.000000)","fill":"#FFFFFF"},React.createElement("polygon",{"points":"95 972.41 93.59 971 88 976.59 82.41 971 81 972.41 86.59 978 81 983.59 82.41 985 88 979.41 93.59 985 95 983.59 89.41 978"})))]);
}

Close.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = Close;

Close.default = Close;
